export const COLOR_MAP = {
  // 🌸 Seasons
  Spring: "#b5ead7",     // soft mint
  Summer: "#ffd3e0",     // strawberry pink
  Autumn: "#f2a6a6",     // coral blush
  Winter: "#c9c1ff",     // lavender snow

  // 🌞 Times of Day
  Morning: "#ffddcc",    // peach sunrise
  Afternoon: "#ccffcc",  // lime mist
  Evening: "#ccccff",    // lavender dusk
  Night: "#ffcccc",      // blush moon

  // 💫 Moods
  Devotional: "#c1f0f6",     // sky temple
  Peaceful: "#bae1ff",       // baby blue
  Serene: "#e0f7fa",         // tranquil aqua
  Introspective: "#f0e6ff",  // quiet lavender
  Romantic: "#ffc9de",       // cherry blossom
  Heroic: "#ffe680",         // golden valor
  Energetic: "#f9a1bc",      // bubblegum zap
  Joyful: "#fff5ba",         // sunny lemon
  Melancholic: "#d3cce3",    // soft twilight
  Pathos: "#f2c6de",         // rose fog
  Longing: "#e6d0f3",        // wistful lilac
  SpringTime: "#c4fcef",     // fresh dew
  Festive: "#ffe0ac",        // mango milk
  Serious: "#e0c3fc",        // calm plum
  Meditative: "#d0f0c0",     // sage peace
  Mysterious: "#dcd6f7",     // misty moon
  Monsoon: "#c3e6e8",        // rainy haze
  Patriotic: "#ffd6a5",      // sunrise orange
  "Light-hearted": "#ffe1f2",  // candy mist
  Auspicious: "#fef7c0",     // golden cream
  Unknown: "#e0e0e0",        // neutral fog

  // Default Raags label color
  Raags: "#d7efff",          // sky cloud
};
